import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/General/Destinations/Views/destinations.html';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import GeneralModule from '@/Pages/Admin/Modules/ManagePackage/Store/General';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {TrekDestinationModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Destinations/TrekDestinationModel';
import {DestinationModel} from '@/Pages/Admin/Modules/Models/Master/DestinationModel';

@WithRender
@Component({
    components: {
        'validation-error': ValidationError,
    },
})
export default class Destinations extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            index: {
                edit: -1,
                delete: -1,
                up: 0,
                down: 0,
            },
            status: {
                isLoading: {
                    getMasterDestinationList: false,
                    getDestinationList: false,
                    createDestination: false,
                    updateDestination: false,
                    deleteDestination: false,
                },
                postLoading: false,
                canAdd: false,
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    delete: {},
                },
            },
        };

        this.item = {
            destinationList: new TrekDestinationModel({}),
            masterDestinationData: new DestinationModel({}),
            addDestination: new DestinationModel({}),
            tempDestination: new DestinationModel({}),
            editDestination: new TrekDestinationModel({}),
            deleteDestination: new TrekDestinationModel({}),
            upDestination: new TrekDestinationModel({}),
            downDestination: new TrekDestinationModel({}),
        };
    }

    public mounted() {
        this.getAllMasterDestinationList();
        this.getAllDestinationList();
    }

    get permission() {
        return common.permissionCheck;
      }

    get getAllGeneralList(): any {
        return GeneralModule.GeneralTabBasic;
    }

    protected async getAllMasterDestinationList() {
        this.ui.status.isLoading.getMasterDestinationList = true;
        trekService
            .getMasterDestinationList()
            .then((res: any) => {
                res.data.data.filter((destination: any) => {
                    destination.IsActive = false;
                });
                this.item.masterDestinationData = res.data.data;
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.getMasterDestinationList = false;
            });
    }

    protected async getAllDestinationList() {
        this.ui.status.isLoading.getDestinationList = true;
        let data = {
            trek_id: this.$route.query.id,
        };
        trekService
            .getDestinationsList(data)
            .then((res: any) => {
                res.data.data.filter((destination: any) => {
                    destination.IsActive = false;
                });
                this.item.destinationList = res.data.data;
            })
            .catch((error: any) => {
                this.ui.error.errors = error;
            })
            .finally(() => {
                this.ui.status.isLoading.getDestinationList = false;
            });
    }

    protected showAddDestinationButton() {
        this.ui.status.canAdd = true;
    }

    protected createDestination() {
        this.resetError();

        if (!this.validateAddDestinationAction()) {
            return;
        }

        let data = {
            trek_id: this.$route.query.id,
            destination_id: this.item.addDestination.id,
        };
        this.ui.status.postLoading.createDestination = true;
        trekService
            .addDestination(data)
            .then((res: any) => {
                this.item.destinationList.unshift(res.data.data);
                flashService.Success('Destination Saved', 'Destination Data has been saved');
                this.ui.status.canAdd = false;
                this.resetError();
                this.item.addDestination = new DestinationModel({});
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.createDestination = false;
            });
    }

    protected validateAddDestinationAction() {
        if (!this.item.addDestination.id) {
            Object.assign(this.ui.error.errors, {destination_id: ['The destination field is required.']});
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected onEditDestinationClick(index: any, destination: any) {
        this.resetError();
        this.ui.status.canEdit = true;
        destination.IsActive = true;
        this.ui.index.edit = index;
        this.item.tempDestination = Object.assign({}, destination);
        this.item.editDestination = destination;
    }

    protected updateDestination() {
        this.resetError();
        if (!this.validateUpdateDestinationAction()) {
            return;
        }
        let data = {
            trek_id: this.$route.query.id,
            destination_id: this.item.editDestination.destination.id, // new replace Destination in the old selected
            id: this.item.editDestination.id, // Old Selected
        };
        this.ui.status.postLoading.updateDestination = true;
        trekService
            .editDestination(data)
            .then((res: any) => {
                this.$set(this.item.destinationList, this.ui.index.edit, res.data.data);
                flashService.Success('General Data Edited', res.data.message);
                this.getAllDestinationList();
                this.ui.status.canEdit = false;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
                flashService.Error('Error', 'Error while saving Destination Datas');
            })
            .finally(() => {
                this.ui.status.postLoading.updateDestination = false;
            });
    }

    protected validateUpdateDestinationAction() {
        if (!this.item.editDestination.id) {
            Object.assign(this.ui.error.errors, {edit_destination_id: ['The destination field is required.']});
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected onCancelDestinationClick(index: any, destinaton: any) {
        this.item.tempDestination.IsActive = false;
        destinaton.IsActive = false;
        this.ui.status.canEdit = false;
        this.item.destinationList[index] = this.item.tempDestination;
    }

    protected onDeleteDestinationClick(index: any, destination: any) {
        this.item.deleteDestination = destination;
        this.ui.index.delete = index;
        this.resetError();
        $('#delete').modal('show');
    }

    protected deleteDestinationAction() {
        this.resetError();
        let data = {
            trek_id: this.$route.query.id,
            id: this.item.deleteDestination.id,
        };
        this.ui.status.postLoading.deleteDestination = true;
        trekService
            .deleteDestination(data)
            .then((res: any) => {
                flashService.Success('Destination Deleted', res.data.message);
                this.$delete(this.item.destinationList, this.ui.index.delete);
                this.hideDeleteDestinationModal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.modal.delete).then(res => {
                    this.ui.error.modal.delete = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.deleteDestination = false;
            });
    }

    protected hideDeleteDestinationModal() {
        this.resetError();
        this.ui.error.modal.delete = {};
        $('#delete').modal('hide');
        $('.modal-backdrop').remove();
        this.item.deleteDestination = {};
        this.ui.index.delete = -1;
    }



    public get buttonName() {
        if (this.ui.status.postLoading.createDestination) {
            return 'Processing...';
        }
        return 'Add destination';
    }

    protected moveDestinationUp(index: any, destination: any) {
        this.resetError();
        this.item.upDestination = this.item.destinationList[index - 1];
        this.ui.index.up = index - 1;
        this.$set(this.item.destinationList, this.ui.index.up, destination);
        this.$set(this.item.destinationList, index, this.item.upDestination);
    }

    protected moveDestinationDown(index: any, destination: any) {
        this.resetError();
        this.item.downDestination = this.item.destinationList[index + 1];
        this.ui.index.down = index + 1;
        this.$set(this.item.destinationList, this.ui.index.down, destination);
        this.$set(this.item.destinationList, index, this.item.downDestination);
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}
